import React, { useEffect, useMemo, useState } from "react";
import Layout from "../../layouts/Layout";
import CreatorInfo from "../../Components/Creators/CreatorInfo";
import AllContentGallery from "../../Components/Creators/CreatorContentGallery";
import HeadingWithBtns from "../../Components/Common/HeadingWithBtns";
import AnalyticsBoxes from "../../Components/Creators/AnalyticsBoxes";
import CustomTabs from "../../Components/Common/CustomTabs";
import {
  Box,
  Grid2,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserPaidVideos,
  getUserPosts,
} from "../../redux/actions/posts.dispatcher";
import CreatorContentGallery from "../../Components/Creators/CreatorContentGallery";
import {
  followCreator,
  getAllCreators,
  getCreatorsSubscribed,
  getUserById,
  unFollowCreator,
  unSubscribeCreator,
  profileVisit,
} from "../../redux/actions/user.dispatcher";
import ScheduleEvent from "../../Components/ExerciseCalendar/ScheduleEvent";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../utils/config/config";
import { CustomBtn, SecondaryBtn } from "../../Components/Common/CustomBtn";
import SubscribeVideoDrawer from "../../Components/Common/SubscribeVideoDrawer";
import { current } from "@reduxjs/toolkit";
import { East, Reply } from "@mui/icons-material";
import { CustomDropDown } from "../../Components/Common/CustomDropdown";
import { CustomInputLabel } from "../../Components/Creators/CustomInputLabel";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../Components/Common/CustomSnackbar";
import TrainingPlans from "../../Components/Creators/TrainingPlans";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const Creators = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [type, setType] = useState("Paid Videos Content");
  const [calendarComponentState, setCalenderComponentState] = useState(false);
  const [userData, setUserData] = useState(null);
  const { userData: currentUser } = useSelector((state) => state.user);
  const [drawerState, setDrawerState] = useState(false);
  const [paidVideoData, setPaidVideoData] = useState({});
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [tabs, setTabs] = useState("Paid Videos Content");
  const [videosForVisitor, setVideosForVisitor] = useState(null);
  const [creatorEvents, setCreatorEvents] = useState([]);
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });
  const [success, setSuccess] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [subscribedPackage, setSubscribedPackage] = useState(null);
  const [subscribeBtnClicked, setSubscribedBtnClicked] = useState(false);
  const [analytics, setAnalytics] = useState(null);

  const isSubscribed = useMemo(() => {
    if (!userData || !currentUser?.subscribed) return false;
    return currentUser.subscribed.some((sub) => sub.creatorId === userData.id);
  }, [currentUser?.subscribed, userData]);
  const isFollowing = currentUser?.following?.includes(userData?.creatorId);

  const handleChange = (event, newValue) => {
    setTabs(newValue);
  };

  useEffect(() => {
    if (
      isSubscribed &&
      userData?.subscriptions?.length &&
      currentUser?.subscribed?.length
    ) {
      const creatorId = userData.creatorId ?? userData.id;

      const matched = currentUser.subscribed.find(
        (s) => s.creatorId === creatorId
      );

      const matchedPackage = userData.subscriptions.find(
        (sub) => sub.packageName === matched?.package
      );

      if (matchedPackage) {
        setSubscribedPackage(matchedPackage);
        setSelectedPackage(matchedPackage); // ✅ Ensures dropdown reflects this
      }
    }
  }, [isSubscribed, userData?.subscriptions, currentUser?.subscribed]);

  const tabsData = [
    {
      id: 1,
      label: "Content",
      value: "Paid Videos Content",
    },
    {
      id: 2,
      label: "Training Plans",
      value: "training",
    },
  ];

  const dispatch = useDispatch();
  const fetchUser = async () => {
    try {
      const user = await axiosInstance.get(
        `/user/getSpecificUser?userId=${id}`
      );

      setUserData(user.data.user);

      fetchPostsForUser(user.data.user.id);
    } catch (err) {
      console.log(err);
    }
  };
  const { userPosts, userPaidVideos } = useSelector((state) => state.posts);

  const handleUnsubscribe = async (id) => {
    try {
      const response = await unSubscribeCreator(id);

      // Immediately update local state
      if (response) {
        dispatch(getAllCreators());
        dispatch(getUserById(currentUser.id));
        fetchUser();
      }
      // setIsSubscribed(false); // Update the state directly after unsubscribing

      // Refresh the global state
    } catch (err) {
      console.log(err);
    }
  };

  const fetchPostsForUser = async (creatorId) => {
    try {
      const response = await axiosInstance.get(
        `/user/fetchProfilePosts?creatorId=${creatorId}`
      );

      if (response.status === 200) {
        setVideosForVisitor(response.data);
      }
    } catch (error) {
      console.log(error, "error, fetch post user");
    }
  };

  const fetchAnalytics = async () => {
    try {
      const resp = await axiosInstance.get(`user/analytics/${userData.id}`);

      setAnalytics(resp.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchCreatorEvents = async () => {
    try {
      const eventsResponse = await axiosInstance.get(
        `/exerciseevent/getExerciseEventsByUser?userId=${id}`
      );

      setCreatorEvents(eventsResponse.data.exerciseEvents);
    } catch (error) {
      console.log(error);
    }
  };

  const markProfileView = async () => {
    const response = await profileVisit(userData.id);
  };

  useEffect(() => {
    fetchUser();
    dispatch(getUserById(currentUser.id));
    dispatch(getUserPosts(id));
    dispatch(getUserPaidVideos());
    dispatch(getCreatorsSubscribed());
  }, []);

  useEffect(() => {
    if (
      isSubscribed &&
      userData &&
      userData.subscriptions &&
      currentUser?.subscribed
    ) {
      const subscribedPackage = userData.subscriptions.find((sub) =>
        currentUser.subscribed.some(
          (s) => s.creatorId === userData.id && s.package === sub.packageName
        )
      );

      setSubscribedPackage(subscribedPackage);
      setSelectedPackage(subscribedPackage);
    }
  }, [isSubscribed, userData?.subscriptions?.length, currentUser?.subscribed]);

  useEffect(() => {
    if (userData) {
      fetchCreatorEvents();
      fetchAnalytics();
      markProfileView();
    }
  }, [userData]);

  return (
    <Elements stripe={stripePromise}>
      <Layout>
        <HeadingWithBtns
          creator={userData}
          analytics
          drawerState={drawerState}
          setDrawerState={setDrawerState}
        />

        <ErrorSnackbar
          error={errorState.error}
          errorMsg={errorState.message}
          handleCloseError={() => setErrorState({ error: false, message: "" })}
        />
        <ConfirmationSnackbar
          snackbarState={success}
          handleSnackbarClose={() => setSuccess(false)}
          text={"Profile URL Copied to clipboard!."}
        />

        {userData && (
          <CreatorInfo
            userData={userData}
            isSelf
            isAdmin={currentUser.role === "admin"}
          />
        )}

        <AnalyticsBoxes
          setCalenderComponentState={setCalenderComponentState}
          isSubscribed={isSubscribed}
          teir={selectedPackage}
          isAdmin={currentUser?.role === "admin"}
          visitingId={userData?.id}
          data={analytics}
        />

        {currentUser?.role !== "admin" && userData && (
          <>
            <Stack
              direction={"row"}
              sx={{ display: "flex", alignItems: "center", mt: 2 }}
              gap={2}
            >
              <SecondaryBtn
                text={isSubscribed ? "Unsubscribe" : "Subscribe"}
                Icon={East}
                width={"50%"}
                padding={"20px"}
                noMb
                noMt
                onClick={() => {
                  if (!isSubscribed) {
                    if (!smallScreen) {
                      setDrawerState(true);
                    } else {
                      // setSubscribedBtnClicked(true);
                      navigate("/subscriptionform/creator", {
                        state: {
                          creatorData: userData,
                          setup: null,
                        },
                      });
                    }
                  } else {
                    handleUnsubscribe(userData.id);
                  }
                }}
              />

              <SecondaryBtn
                text={isFollowing ? "UnFollow" : "Follow"}
                Icon={East}
                width={"50%"}
                padding={"20px"}
                noMb
                noMt
                onClick={async () => {
                  if (!isFollowing) {
                    const resp = await followCreator(userData.creatorId);
                    if (resp) {
                      dispatch(getUserById(currentUser.id));
                    }
                  } else {
                    const resp = await unFollowCreator(userData.creatorId);
                    if (resp) {
                      dispatch(getUserById(currentUser.id));
                    }
                  }
                }}
              />
            </Stack>

            {isSubscribed && (
              <Grid2 item size={{ xs: 12, md: 6 }} sx={{ mt: 2 }}>
                <CustomInputLabel text="Change Package" mt={2} />
                <CustomDropDown
                  value={selectedPackage?.id || ""} // or use selectedSubscription state
                  setValue={(id) => {
                    const fullPackage = userData.subscriptions.find(
                      (p) => p.id === id
                    );
                    setSelectedPackage(fullPackage);

                    if (!smallScreen) {
                      setDrawerState(true);
                    } else {
                      setSubscribedBtnClicked(true);
                      navigate("/subscriptionform/creator", {
                        state: {
                          creatorData: userData,
                          setup: null,
                        },
                      });
                    }
                  }}
                  title="Subscription Package"
                  label="Subscription Package"
                  data={userData.subscriptions.map((sub) => ({
                    id: sub.id,
                    label: sub.packageName,
                    value: sub.id, // use primitive
                  }))}
                  noIcon
                  noMt
                />
              </Grid2>
            )}
            {/* {isSubscribed && (
            <Grid2 item size={{ xs: 12, md: 6 }} sx={{ mt: 2 }}>
              <CustomInputLabel text="Subscribed Package" mt={2} />
              <CustomDropDown
                value={subscribedPackage?.id || ""}
                setValue={(id) => {
                  if (subscribedPackage.id === id) {
                    return;
                  }
                  const fullPackage = userData.subscriptions.find(
                    (p) => p.id === id
                  );
                  setSelectedPackage(fullPackage);

                  if (!smallScreen) {
                    setDrawerState(true);
                  } else {
                    setSubscribedBtnClicked(true);
                    navigate("/subscriptionform/creator", {
                      state: {
                        creatorData: userData,
                        packageDetails: fullPackage,
                      },
                    });
                  }
                }}
                title="Subscription Package"
                label="Susbcription Package"
                data={userData.subscriptions.map((sub) => ({
                  id: sub.id,
                  label: sub.packageName,
                  value: sub.id,
                }))}
                noIcon
                noMt
              />
            </Grid2>
          )} */}
            <Stack
              direction={"row"}
              sx={{ display: "flex", alignItems: "center", mt: 2 }}
              gap={2}
            >
              <SecondaryBtn
                text="Share"
                Icon={Reply}
                width={"100%"}
                noMb
                noMt
                black
                onClick={() => {
                  try {
                    const url = `${process.env.REACT_APP_STAGING_FRONTEND_URL}/profile/${userData.id}`;
                    navigator.clipboard.writeText(url);
                    setSuccess(true);
                  } catch (err) {
                    setErrorState({
                      error: true,
                      message: "Error copying URL.",
                    });
                  }
                }}
              />
            </Stack>
          </>
        )}
        <ScheduleEvent
          drawerState={calendarComponentState}
          setDrawerState={setCalenderComponentState}
          creatorId={userData?.id}
          type="video"
        />

        <SubscribeVideoDrawer
          drawerState={drawerState}
          setDrawerState={setDrawerState}
          paidVideoData={paidVideoData}
          setSuccess={setSuccess}
          type="creator"
          creatorData={userData}
        />

        {smallScreen ? (
          <>
            <Box sx={{ width: "100%", overflow: "hidden", mt: 4 }}>
              <Tabs
                value={tabs}
                onChange={handleChange}
                textColor="inherit"
                indicatorColor="#FC0108"
                aria-label="secondary tabs example"
                sx={{
                  width: "100%", // Prevents overflow
                  display: "flex",
                  justifyContent: "center",
                  "& .MuiTab-root": {
                    fontSize: "12px",
                    flex: 1, // Makes tabs equal width
                    maxWidth: "50%", // Restricts each tab to 50% width
                    borderBottom: "2px solid #000", // Black border for unselected tabs
                    opacity: 1,
                  },
                  "& .Mui-selected": {
                    color: "#FC0108", // Selected tab text color
                    borderBottom: "2px solid #FC0108 !important", // Red border for selected tab
                  },
                  "& .MuiTabs-indicator": {
                    backgroundColor: "#FC0108", // Red indicator color
                  },
                }}
              >
                <Tab
                  sx={{
                    px: 1,
                  }}
                  value="Paid Videos Content"
                  label="Content"
                />
                <Tab
                  sx={{
                    px: 1,
                  }}
                  value="training"
                  label="Training Plans"
                />
              </Tabs>
            </Box>

            <Box>
              {tabs == "Paid Videos Content" ? (
                <CreatorContentGallery
                  title="Available Videos"
                  type="videos"
                  allData={videosForVisitor || []}
                />
              ) : (
                <TrainingPlans
                  title="Training Plans"
                  type="training"
                  allData={creatorEvents || []}
                />
              )}
            </Box>
          </>
        ) : (
          <>
            <Box
              sx={{
                mt: 4,
              }}
            >
              <CustomTabs
                data={tabsData}
                value={type}
                setValue={setType}
                fullScreen
              />
            </Box>

            <Box
              sx={{
                mt: 4,
              }}
            >
              {type === "Paid Videos Content" ? (
                <CreatorContentGallery
                  title="Available Content"
                  type="videos"
                  allData={videosForVisitor || []}
                  setDrawerState={setDrawerState}
                />
              ) : type === "videos" ? (
                <CreatorContentGallery
                  title="Paid Videos"
                  type="videos"
                  allData={userPaidVideos || []}
                />
              ) : type === "training" ? (
                <TrainingPlans
                  title="Training Plans"
                  type="training"
                  allData={creatorEvents || []}
                />
              ) : (
                <CreatorContentGallery
                  title="Subscribed Users"
                  type="creators"
                />
              )}
            </Box>
          </>
        )}
      </Layout>
    </Elements>
  );
};

export default Creators;
